/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Сообщение об ошибке
 */
export interface ErrorMessage {
  /** @format date-time */
  timestamp?: string;

  /** @format int32 */
  status?: number;
  error?: string;
  path?: string;
}

/**
 * Запрос при редактировании события
 */
export interface EventUpdateRequest {
  /**
   * Идентификатор события
   * @format uuid
   */
  id: string;

  /** Наименование события */
  name: string;

  /**
   * Дата начала события
   * @format date
   */
  startDate?: string;

  /**
   * Дата окончания события
   * @format date
   */
  endDate?: string;

  /**
   * Время начала выполнения
   * @format date-time
   */
  startDateTime?: string;

  /**
   * Время окончания выполнения
   * @format date-time
   */
  endDateTime?: string;

  /** Просрочено */
  isExpired?: boolean;

  /** Признак важности */
  isImportant?: boolean;
}

/**
 * Универсальный ответ со значением crmClientId
 */
export interface CommonResponse {
  /**
   * Идентификатор клиента / организации
   * @format uuid
   */
  crmClientId?: string;
}

/**
 * Запрос при получении списка событий
 */
export interface EventListRequest {
  /** Тип событий: налоги, отчеты */
  taxesAndReportsTypeIds: string[];

  /** Тип событий: личные, рабочие */
  eventTypeIds: string[];

  /**
   * Форма собственности
   * @format uuid
   */
  ownershipFormId: string;

  /**
   * Система налогообложения
   * @format uuid
   */
  taxationSystemId: string;

  /**
   * Количество сотрудников
   * @format uuid
   */
  employeesNumberId: string;

  /**
   * Дата, с которой пользователь запрашивает события
   * @format date
   */
  startDate: string;

  /**
   * Дата, по которую пользователь запрашивает события
   * @format date
   */
  endDate: string;

  /** Просрочено */
  isExpired?: boolean;

  /** Признак важности задачи */
  isImportant?: boolean;
}

export interface EventData {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  crmResponsibleId?: string;

  /** @format uuid */
  typeId?: string;
  typeName?: string;
  name?: string;
  description?: string;

  /** @format date */
  startDate?: string;

  /** @format date */
  endDate?: string;

  /** @format date-time */
  startDateTime?: string;

  /** @format date-time */
  endDateTime?: string;

  /** @format date-time */
  createDateTime?: string;

  /** @format date-time */
  updateDateTime?: string;

  /** @format uuid */
  taskId?: string;
  isExpired?: boolean;
  isImportant?: boolean;
}

/**
 * Ответ при получении списка событий
 */
export interface EventListResponse {
  /** @format uuid */
  crmClientId?: string;
  taxesAndReports?: TaxAndReportData[];
  events?: EventData[];
}

export interface TaxAndReportData {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  typeId?: string;
  typeName?: string;

  /** @format uuid */
  ownershipFormId?: string;
  ownershipFormShortName?: string;

  /** @format uuid */
  taxationSystemId?: string;
  taxationSystemShortName?: string;

  /** @format uuid */
  employeesNumberId?: string;
  employeesNumberName?: string;
  name?: string;

  /** @format date */
  startDate?: string;

  /** @format date */
  endDate?: string;

  /** @format date-time */
  createDateTime?: string;

  /** @format date-time */
  updateDateTime?: string;
}

/**
 * Запрос при создании события
 */
export interface EventCreationRequest {
  /**
   * Тип события
   * @format uuid
   */
  typeId: string;

  /** Наименование события */
  name: string;

  /**
   * Дата начала события
   * @format date
   */
  startDate?: string;

  /**
   * Дата окончания события
   * @format date
   */
  endDate?: string;

  /**
   * Время начала выполнения
   * @format date-time
   */
  startDateTime?: string;

  /**
   * Время окончания выполнения
   * @format date-time
   */
  endDateTime?: string;

  /** Просрочено */
  isExpired?: boolean;

  /** Признак важности */
  isImportant?: boolean;
}

export interface EmployeeNumberData {
  /** @format uuid */
  id?: string;
  name?: string;
}

export interface OwnershipFormData {
  /** @format uuid */
  id?: string;
  name?: string;
  shortName?: string;
}

/**
 * Ответ при получении настроек
 */
export interface SettingsResponse {
  /** @format uuid */
  crmClientId?: string;
  employeesNumbers?: EmployeeNumberData[];
  ownershipForms?: OwnershipFormData[];
  taxationSystems?: TaxationSystemData[];
}

export interface TaxationSystemData {
  /** @format uuid */
  id?: string;
  name?: string;
  shortName?: string;
}

export interface NonWorkingPeriodData {
  /** @format uuid */
  id?: string;

  /** @format uuid */
  typeId?: string;
  typeName?: string;
  name?: string;

  /** @format date */
  startDate?: string;

  /** @format date */
  endDate?: string;

  /** @format date-time */
  createDateTime?: string;

  /** @format date-time */
  updateDateTime?: string;
}

/**
 * Ответ при получении списка нерабочих дней
 */
export interface VacationDataResponse {
  /** @format uuid */
  crmClientId?: string;
  nonWorkingPeriods?: NonWorkingPeriodData[];
}

export interface EventTypeData {
  /** @format uuid */
  id?: string;
  name?: string;
}

/**
 * Ответ при получении списка типов событий
 */
export interface EventTypeResponse {
  /** @format uuid */
  crmClientId?: string;
  eventTypes?: EventTypeData[];
}

/**
 * Карточка события
 */
export interface EventCard {
  /** @format uuid */
  crmClientId?: string;
  eventData?: EventData;
}

/**
 * Запрос при удалении события
 */
export interface EventDeletionRequest {
  /** Массив идентификаторов событий на удаление */
  eventsIds: string[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис crm-ms-prd-calendar
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://crm-ms-prd-calendar.crmdbo.dev.rshbdev.ru
 * @contact https://sdlc.go.rshbank.ru/jira/projects/OB_SAAS <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=196385940)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags События
     * @name UpdateEvent
     * @summary Редактирование события
     * @request PUT:/api/calendar/external/v1/event/edit
     */
    updateEvent: (data: EventUpdateRequest, params: RequestParams = {}) =>
      this.request<CommonResponse, ErrorMessage>({
        path: `/api/calendar/external/v1/event/edit`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags События
     * @name GetEventList
     * @summary Получение списка событий
     * @request POST:/api/calendar/external/v1/events
     */
    getEventList: (data: EventListRequest, params: RequestParams = {}) =>
      this.request<EventListResponse, ErrorMessage>({
        path: `/api/calendar/external/v1/events`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags События
     * @name CreateEvent
     * @summary Создание события
     * @request POST:/api/calendar/external/v1/event/create
     */
    createEvent: (data: EventCreationRequest, params: RequestParams = {}) =>
      this.request<CommonResponse, ErrorMessage>({
        path: `/api/calendar/external/v1/event/create`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контроллер справочной информации
     * @name GetSettings
     * @summary Получение настроек
     * @request GET:/api/calendar/external/v1/settings
     */
    getSettings: (params: RequestParams = {}) =>
      this.request<SettingsResponse, ErrorMessage>({
        path: `/api/calendar/external/v1/settings`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контроллер нерабочих дней
     * @name GetVacationData
     * @summary Получение списка нерабочих дней
     * @request GET:/api/calendar/external/v1/non-working-periods
     */
    getVacationData: (
      query: { startDate: string; endDate: string },
      params: RequestParams = {}
    ) =>
      this.request<VacationDataResponse, ErrorMessage>({
        path: `/api/calendar/external/v1/non-working-periods`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Контроллер справочной информации
     * @name GetEventTypes
     * @summary Получение списка типов событий
     * @request GET:/api/calendar/external/v1/event/types
     */
    getEventTypes: (params: RequestParams = {}) =>
      this.request<EventTypeResponse, ErrorMessage>({
        path: `/api/calendar/external/v1/event/types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags События
     * @name GetEvent
     * @summary Получение карточки события
     * @request GET:/api/calendar/external/v1/event/card
     */
    getEvent: (query: { id: string }, params: RequestParams = {}) =>
      this.request<EventCard, ErrorMessage>({
        path: `/api/calendar/external/v1/event/card`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags События
     * @name DeleteEvent
     * @summary Удаление событий
     * @request DELETE:/api/calendar/external/v1/event/delete
     */
    deleteEvent: (data: EventDeletionRequest, params: RequestParams = {}) =>
      this.request<CommonResponse, ErrorMessage>({
        path: `/api/calendar/external/v1/event/delete`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
